import { render, staticRenderFns } from "./promoters.vue?vue&type=template&id=29b4f730"
import script from "./promoters.vue?vue&type=script&lang=js"
export * from "./promoters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports